import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

import Paragraph from './Paragraph'
import Title from './Title'

const NoticeBox = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      flexDirection="column"
      flexShrink={0}
      lineHeight="1.3"
      marginBottom="large"
      padding="large"
      variant="whiteGrey"
      {...boxProps}
    >
      {children}
    </Box>
  )
}

NoticeBox.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

NoticeBox.Paragraph = Paragraph
NoticeBox.Title = Title

export default NoticeBox
